import React, { useEffect, useState } from "react";
import styles from "./TermsConditions.module.css";
import { TextComponent } from "../../components";
import { useDispatch, useSelector } from "react-redux";
import { PagesMiddleware } from "../../Store/Middlewares/PagesMiddleware";
import { Skeleton } from "antd";
import HeaderComponent from "../../components/HeaderComponent/HeaderComponent";
const TermsConditions = () => {
    const [loading, setLoading] = useState(false);
 

  

  const dummyItem = [
 
    {
      id: 2,
       text: "As a user, you have the responsibility to provide accurate and up-to-date information when using our services. This includes ensuring that your personal details, such as your name, email address, and phone number, are correct and valid. Additionally, it is important to understand and acknowledge our use of cookies and tracking technologies to improve your overall experience.",
    },
    {
      id: 3,
       text: "You are prohibited from sharing your account credentials with others. Please ensure that your login details and password are kept confidential and not disclosed to anyone else. This helps maintain the security of your account and protects your personal information from unauthorized access.",
    },
    {
      id: 4,
       text: "Protecting your personal information is a top priority for us. We are committed to safeguarding your data and ensuring that it is used appropriately. By using our services, you agree to our privacy policy and the collection of certain information to enhance your user experience.",
    },
  ];
  return (
    <div className={styles.mainCont}>
           <TextComponent text={'Terms & Condition'} className={styles.HeadText}/> 

      {dummyItem?.map((item, index) => (
        <div className={styles.listItem}>
          <TextComponent text={item?.title} style={{color: "var(--black-color)", fontFamily: "Urbanist-bold", marginBottom: "10px", fontSize: "30px"}} />
          <TextComponent text={item?.text} style={{ fontSize: "14px", color: "#525252"}}/>
        </div>
      ))}
      <TextComponent textClass={styles.tcText}>
        {/* <span
          className={styles.contentStyling}
          dangerouslySetInnerHTML={{ __html: pages?.terms_and_condition }}
        /> */}
      </TextComponent>
     </div>
  );
};

export default TermsConditions;
